<main class="home">
  <!-- HERO -->
  <section class="hero">
    <div class="container-xl">
      <div class="hero-shell">
        <div class="row align-items-center g-4">
          <div class="col-12 col-lg-6">
            <p class="hero-badge mb-2">
              <i class="fa-solid fa-location-dot"></i>
              SAMI Pulizie • Sedi di Pescara e Giulianova
            </p>

            <h1 class="hero-title">
              Pulizie a Pescara
              <span class="hero-accent">per case, uffici e condomini</span>
            </h1>

            <p class="hero-subtitle">
              Pulizie professionali per uffici, condomini, palestre, sanificazioni e ambienti domestici.
              Scegli la sede di Pescara o Giulianova: concordiamo un sopralluogo gratuito
              e prepariamo un preventivo su misura, senza impegno.
            </p>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <button class="btn-sami" (click)="navigateToPreventiviSito()">Richiedi un preventivo</button>
              <button class="btn-sami-outline" (click)="navigateToServices()">Scopri i servizi</button>
            </div>

            <div class="hero-chips mt-4">
              <div class="chip"><i class="fa-solid fa-shield-halved"></i> Affidabilità</div>
              <div class="chip"><i class="fa-solid fa-clock"></i> Puntualità</div>
              <div class="chip"><i class="fa-solid fa-leaf"></i> Prodotti sicuri</div>
              <div class="chip"><i class="fa-solid fa-user-check"></i> Team formato</div>
            </div>
          </div>

          <div class="col-12 col-lg-6">
            <div class="hero-media">
              <img
                src="assets/family.JPG"
                alt="Foto di gruppo davanti alla sede SAMI Pulizie"
                class="hero-img"
                width="1600"
                height="1200"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />

              <div class="hero-float card-sami">
                <div class="float-title">Preventivo gratuito</div>
                <div class="float-text">Sopralluogo senza impegno.</div>
              </div>
            </div>
          </div>
        </div>

        <div class="stats">
          <div class="stat card-sami">
            <div class="stat-num">Su misura</div>
            <div class="stat-txt">piano per i tuoi ambienti</div>
          </div>
          <div class="stat card-sami">
            <div class="stat-num">Gratuito</div>
            <div class="stat-txt">sopralluogo senza impegno</div>
          </div>
          <div class="stat card-sami">
            <div class="stat-num">Due sedi</div>
            <div class="stat-txt">Pescara e Giulianova</div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- NUOVA SEDE GIULIANOVA -->
  <section class="section location-launch" aria-labelledby="giulianova-title">
    <div class="container-xl">
      <div class="location-launch-card card-sami">
        <div class="location-launch-icon" aria-hidden="true">
          <i class="fa-solid fa-location-dot"></i>
        </div>
        <div>
          <p class="location-eyebrow">SEDE DI GIULIANOVA</p>
          <h2 id="giulianova-title" class="section-title">La sede SAMI Pulizie di Giulianova</h2>
          <p class="location-copy">
            Contatta la sede di <strong>Corso Nazario Sauro 118,
            Giulianova</strong>, per richiedere un servizio a Teramo e provincia: pulizia di condomini,
            uffici, attività commerciali, palestre, ambienti domestici, sanificazioni e interventi
            straordinari.
          </p>
          <p class="location-areas">
            Serviamo anche Roseto degli Abruzzi, Alba Adriatica, Tortoreto, Silvi, Pineto,
            Mosciano Sant’Angelo, Martinsicuro, Atri, Bellante, Notaresco, Castellalto,
            Sant’Egidio alla Vibrata e località limitrofe.
          </p>
          <a class="btn-sami location-link" routerLink="/impresa-pulizie-giulianova-teramo">
            Scopri la nuova area operativa
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- PERCHÉ SCEGLIERCI -->
  <section class="section section-soft">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="section-title">Perché scegliere SAMI Pulizie</h2>
        <p class="section-subtitle">I nostri punti di forza che ci distinguono</p>
      </div>

      <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3 justify-content-center">
        <div class="col">
          <div class="feature card-sami">
            <div class="feature-icon"><i class="fa-solid fa-wand-magic-sparkles"></i></div>
            <h3 class="feature-title">Pulizie professionali</h3>
            <p class="feature-text">Servizi completi per ogni tipo di ambiente.</p>
          </div>
        </div>

        <div class="col">
          <div class="feature card-sami">
            <div class="feature-icon"><i class="fa-solid fa-shield-halved"></i></div>
            <h3 class="feature-title">Prodotti certificati</h3>
            <p class="feature-text">Utilizziamo prodotti selezionati e sicuri.</p>
          </div>
        </div>

        <div class="col">
          <div class="feature card-sami">
            <div class="feature-icon"><i class="fa-solid fa-clock"></i></div>
            <h3 class="feature-title">Puntualità garantita</h3>
            <p class="feature-text">Rispettiamo sempre gli orari concordati.</p>
          </div>
        </div>

        <div class="col">
          <div class="feature card-sami">
            <div class="feature-icon"><i class="fa-solid fa-users"></i></div>
            <h3 class="feature-title">Team esperto</h3>
            <p class="feature-text">Personale qualificato e formato professionalmente.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- SERVIZI -->
  <section id="servizi" class="section section-tint">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="section-title">I nostri servizi</h2>
        <p class="section-subtitle">Info rapide o preventivo immediato: scegli il servizio.</p>
      </div>

      <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-3">
        <div class="col" *ngFor="let s of services; trackBy: trackByTitle">
          <div class="service card-sami h-100">
            <div class="service-media">
              <img
                [src]="s.img"
                [alt]="s.title + ' - SAMI Pulizie'"
                class="service-img"
                width="900"
                height="600"
                loading="lazy"
                decoding="async"
              />
              <div class="service-badge">Servizio</div>
            </div>

            <div class="card-body">
              <h3 class="h5 fw-bold mb-2">{{ s.title }}</h3>
              <div class="d-flex gap-2">
                <button class="btn-sami-outline flex-fill" (click)="navigateToService(s.link)">Informazioni complete</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="services-cta card-sami mt-4">
        <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
          <div>
            <div class="services-cta-title">Hai bisogno di un piano su misura?</div>
            <div class="services-cta-text">Descrivici l’ambiente e ti rispondiamo rapidamente.</div>
          </div>
          <button class="btn-sami" (click)="navigateToPreventiviSito()">Richiedi preventivo</button>
        </div>
      </div>
    </div>
  </section>

  <!-- LAVORA CON NOI -->
  <section class="section-cta join">
    <div class="container-xl text-center">
      <h2 class="join-title">Cerchi lavoro? Unisciti al nostro team!</h2>
      <p class="join-text">
        Siamo sempre alla ricerca di persone motivate e professionali. Scopri le opportunità di lavoro.
      </p>
      <button class="btn btn-light join-btn" (click)="navigateToLavoraConNoi()">
        Invia la tua candidatura
      </button>
    </div>
  </section>

  <!-- COLLABORATORI -->
  <section class="section section-soft">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="section-title">I nostri migliori collaboratori</h2>
        <p class="section-subtitle">
          Collaboriamo con realtà selezionate sul territorio. I loghi portano ai siti ufficiali.
        </p>
      </div>

      <div class="logos-shell card-sami">
        <div class="logos-scroll-container" #scrollContainer>
          <ul class="logos-track" aria-label="Loghi collaboratori">
            <li class="logos-item" *ngFor="let p of partners; trackBy: trackByPartnerName">
              <a
                class="logos-link"
                [href]="p.url"
                target="_blank"
                rel="noopener sponsored"
                [attr.aria-label]="'Visita il sito di ' + p.name"
                [title]="p.name"
              >
                <img
                  class="logos-img"
                  [src]="p.logo"
                  [alt]="'Logo ' + p.name"
                  width="260"
                  height="150"
                  loading="lazy"
                  decoding="async"
                />
              </a>
            </li>

            <li class="logos-item" *ngFor="let p of partners">
              <a
                class="logos-link"
                [href]="p.url"
                target="_blank"
                rel="noopener sponsored"
                [attr.aria-label]="'Visita il sito di ' + p.name"
                [title]="p.name"
                tabindex="-1"
              >
                <img
                  class="logos-img"
                  [src]="p.logo"
                  [alt]="'Logo ' + p.name"
                  width="260"
                  height="150"
                  loading="lazy"
                  decoding="async"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- FIDUCIA E PASSAGGI DEL PREVENTIVO -->
  <section class="section section-soft">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="section-title">Persone reali, sedi che puoi contattare</h2>
        <p class="section-subtitle">Ci trovi a Pescara in Via Tirino 145 e a Giulianova in Corso Nazario Sauro 118.</p>
      </div>
      <div class="row g-3">
        <div class="col-12 col-md-4"><div class="card-sami p-4 h-100"><h3 class="h5">1. Raccontaci cosa serve</h3><p>Scegli la sede e il servizio. Lascia un recapito per essere ricontattato.</p></div></div>
        <div class="col-12 col-md-4"><div class="card-sami p-4 h-100"><h3 class="h5">2. Concordiamo il sopralluogo</h3><p>Valutiamo ambienti, frequenza ed esigenze. Il sopralluogo è gratuito.</p></div></div>
        <div class="col-12 col-md-4"><div class="card-sami p-4 h-100"><h3 class="h5">3. Ricevi la proposta</h3><p>Un preventivo personalizzato, senza impegno, da valutare prima di decidere.</p></div></div>
      </div>
      <div class="text-center mt-4"><a class="btn-sami" routerLink="/preventivo">Richiedi il sopralluogo gratuito</a></div>
    </div>
  </section>

  <!-- MAP -->
  <section class="section">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="section-title">Le nostre sedi operative</h2>
        <p class="section-subtitle">
          Pescara: Via Tirino 145. Giulianova: Corso Nazario Sauro 118, contattaci per concordare il servizio.
        </p>
      </div>

      <div class="col-12 col-md-10 col-lg-8 mx-auto">
        <div class="ratio ratio-16x9 map-shell">
          <iframe
            title="Mappa sede SAMI Pulizie - Via Tirino 145, Pescara"
            loading="lazy"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2843.2073!2d14.2181475!3d42.4462893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1331a6223b8afae7%3A0xe0f8329b5888d54d!2sVia%20Tirino%2C%20145%2C%20Pescara!5e0!3m2!1sit!2sit!4v1713538014550"
            allowfullscreen
            style="border:0;"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </div>
  </section>

  <!-- WhatsApp -->
  <div class="position-fixed bottom-0 end-0 mb-4 me-4" style="z-index:1050;">
    <a
      href="https://wa.me/3515034934"
      target="_blank"
      rel="noopener"
      aria-label="Chatta su WhatsApp"
      class="btn btn-success rounded-circle btn-sm"
    >
      <i class="fa-brands fa-whatsapp fa-2x"></i>
    </a>
  </div>

</main>
